import React from 'react';
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import { ROUTE_RESET_PASSWORD } from '../../../constants/routeconstants';
import ProfileForm from '../../reusable/profile/ProfileForm';
import * as AuthActions from '../../../actions/auth';


class ResetPasswordPage extends React.Component {

    static getId() {
        return ROUTE_RESET_PASSWORD;
    }

    static getAllowedRoles() {
        return []; // empty means allowed for all
    }

    render() {
        return (
            <div className="reset-password-page">
                <div className="sub-page-title" key="title">
                    <h1>Reset password</h1>
                </div>,
                <div className="sub-page-content" key="content">
                    <ProfileForm profile={null} resetPassword={true} onSubmit={this.handleSubmit} submitButtonText="Reset password"
                                 params={this.props.location.query}/>
                </div>
            </div>
        );
    }

    handleSubmit = (newPassword) => {
        const userId = Number(this.props.location.query.u);
        const resetCode = this.props.location.query.c;

        this.props.dispatch(AuthActions.resetPassword({
            userId: userId,
            resetCode: resetCode,
            newPassword: newPassword
        }, () => {
            NotificationManager.success("Your password has been reset.", "Password reset", 4000);
            //dispatch(push('/signin'));
        }));
    };
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps)(ResetPasswordPage);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/resetpassword/ResetPasswordForm.js